import { hardcodedSettingsServices } from './services';
import { hardcodedSettingsConstants } from './constants';

export const hardcodedSettingsActions = {
    getSuperAdmins
};

function getSuperAdmins () {
    return dispatch => {
        dispatch(request());

        return hardcodedSettingsServices.getSuperAdmins()
            .then(
                data => dispatch(success(data)),
                error => dispatch(failure(error))
            );
    };

    function request () {
        return { type: hardcodedSettingsConstants.GET_SUPER_ADMINS_REQUEST };
    }

    function success (data) {
        return {
            type: hardcodedSettingsConstants.GET_SUPER_ADMINS_SUCCESS,
            payload: data
        };
    }

    function failure (error) {
        return {
            type: hardcodedSettingsConstants.GET_SUPER_ADMINS_ERROR,
            error
        };
    }
}
